// @flow
import React, { Component } from "react";
import classNames from "classnames";
import { withGlobalContext } from "../../common/GlobalContext";
import enhanceWithClickOutside from "react-click-outside";
import withStyles from "elevate-ui/withStyles";

import RenderNav from "../RenderNav";

type $Props = {
  classes: Object,
  onCloseDropdown: Function,
  compliance: Object,
  openDropdowns: Object,
  onToggleDropdown: Function,
  renderNavItems: Function,
};

class DefaultNav extends Component<$Props> {
  handleClickOutside() {
    this.props.onCloseDropdown();
  }
  render() {
    const { classes, compliance, openDropdowns, onToggleDropdown } = this.props;

    return (
      <header
        className={classNames(classes.root, {
          [classes.stickyHeaderMargin]:
            compliance &&
            (compliance.stickyHeader ||
              compliance.stickyHeaderCustom ||
              compliance.stickyHeaderMobile),
          [classes.stickerHeaderMarginLarge]:
            compliance &&
            (compliance.stickyHeader || compliance.stickyHeaderMobile) &&
            compliance.stickyHeaderCustom,
        })}
      >
        <div className={classes.navRow}>
          <div className={classes.navTable}>
            <RenderNav
              openDropdowns={openDropdowns}
              onToggleDropdown={onToggleDropdown}
            />
          </div>
        </div>
      </header>
    );
  }
}

const styles = (theme) => ({
  "@global": {
    "header a svg, header li svg": {
      verticalAlign: "top",
      marginTop: "-2px",
    },
  },
  root: {
    boxSizing: "border-box",
    position: "relative",
    color: theme.colors.white,
    backgroundColor: theme.colors.primary["500"],
    [theme.breakpoints(900)]: {
      minHeight: "50px",
      textAlign: "left",
      lineHeight: "1.5",
      padding: "0px",
      fontSize: "13px",
      zIndex: theme.zIndex["header"],
    },
  },
  stickyHeaderMargin: {
    marginTop: theme.spacing.unit * 1.5,
  },
  stickerHeaderMarginLarge: {
    marginTop: theme.spacing.unit * 3,
  },
  navRow: {
    flex: "1 1 0%",
    display: "flex",
    flexDirection: "column",
  },
  navTable: {
    paddingLeft: 0,
    marginBottom: 0,
    listStyle: "none",
    flex: "1 1 0%",
    display: "block",
  },
});

export default withGlobalContext(
  withStyles(styles)(enhanceWithClickOutside(DefaultNav))
);
